import { ApiService } from './apiService';

/**
 * Sports-only API client.
 * Routes all /api/Sports/* traffic to the sports host.
 */
const sportsApiBase =
  process.env.REACT_APP_SPORTS_API_BASE_URL || 'https://api.apexbet365.com';

export const sportsApiService = new ApiService({
  baseURL: sportsApiBase,
});

export default sportsApiService;

